import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import logger from "./lib/logger";
import * as serviceWorker from "./serviceWorker";
import * as accountActions from "./actions/accountActions";
import store from "./store";
import * as config from "./config";
import TagManager from "react-gtm-module";
import ReactPixel from "react-facebook-pixel";

if (config.googleTagManagerId) {
  const tagManagerArgs = {
    gtmId: config.googleTagManagerId
  };

  TagManager.initialize(tagManagerArgs);
}

if (config.facebookPixelTrackingId) {
  const options = {
    autoConfig: true,
    debug: true
  };

  ReactPixel.init(config.facebookPixelTrackingId, {}, options);

  ReactPixel.fbq("track", "PageView");
}

store
  .dispatch(accountActions.getAuthTokenIfNeeded())
  .then(() => {
    return store.dispatch(accountActions.getMe());
  })
  .catch(err => {
    window.location.href = config.loginUrl + "?ReturnUrl=" + window.location.href;
    logger.warn(err);
  })
  .then(() => {
    ReactDOM.render(<App />, document.getElementById("root"));
    serviceWorker.unregister();
  });